import script from "./topView.vue?vue&type=script&setup=true&lang=js"
export * from "./topView.vue?vue&type=script&setup=true&lang=js"

import "./topView.vue?vue&type=style&index=0&id=5b43c51e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b43c51e"]])

export default __exports__